import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  styled as styling,
} from '@mui/material';
// component
import Iconify from '../../../components/iconify';
import { useState } from 'react';
import { years } from 'src/utils/years';
import CloseIcon from '@mui/icons-material/Close';
import { useSearchParams } from 'react-router-dom';

// ----------------------------------------------------------------------

const RemoveButton = styled('div')({
  position: 'absolute',
  right: '30px',
  cursor: 'pointer',
  top: '16px',
  color: '#2065d1',
});

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  maxWidth: 300,
  width: '100%',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    maxWidth: 380,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

const StyledControl = styled(FormControl)`
  width: 170px;
  margin-left: 10px;
  @media (max-width: 500px) {
    width: 100%;
  }
`;
// ----------------------------------------------------------------------

ZakazkyListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};

export default function ZakazkyListToolbar({
  numSelected,
  filterName,
  onFilterName,
  onYearChange,
  year,
  onFazaChange,
  faza,
}) {
  const [filterYear, setFilterYear] = useState('');
  const [searchParams] = useSearchParams();
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Zadajte vyhľadávané slovo"
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}
      {searchParams.get('show') === 'holodom' ||
      searchParams.get('show') === 'hruba' ||
      searchParams.get('show') === 'kluc' ? (
        false
      ) : (
        <StyledControl fullWidth sx={{ marginTop: 0 }}>
          <InputLabel id="typFotovoltiky">Fáza</InputLabel>
          <Select
            label="Fáza"
            name="faza"
            value={faza}
            onChange={(e) => {
              onFazaChange(e.target.value);
            }}
          >
            <MenuItem value={'hrubá stavba'} key={'hruba'}>
              Hrubá stavba
            </MenuItem>
            <MenuItem value={'holodom'} key={'holodom'}>
              Holodom
            </MenuItem>
            <MenuItem value={'na kľúč'} key={'kluc'}>
              Dom na kľúč
            </MenuItem>
          </Select>
          {faza ? (
            <RemoveButton onClick={() => onFazaChange(null)}>
              <CloseIcon />
            </RemoveButton>
          ) : null}
        </StyledControl>
      )}
      {searchParams?.get('show') === 'year' || searchParams?.get('show') === 'month' ? (
        false
      ) : (
        <StyledControl fullWidth sx={{ marginTop: 0 }}>
          <InputLabel id="typFotovoltiky">Rok</InputLabel>
          <Select
            label="Rok"
            name="year"
            value={year}
            onChange={(e) => {
              onYearChange(e.target.value);
            }}
          >
            {years.map((item) => (
              <MenuItem value={item.year} key={item.year}>
                {item.year}
              </MenuItem>
            ))}
          </Select>
          {year ? (
            <RemoveButton onClick={() => onYearChange(null)}>
              <CloseIcon />
            </RemoveButton>
          ) : null}
        </StyledControl>
      )}
    </StyledRoot>
  );
}
